import React, { useState } from "react";
import OldAnnualForm from "./OldAnnualForm";
import NewAnnualForm from "./NewAnnualForm";
import Option from "../Option";
import BackButton from "../../../../../components/common/backbutton/BackButton";


const AnualReturns = () => {
  const [turnOn, setTurnOn] = useState(true)  
  
  return (
    <div className="px-10 lg:!px-14">
      {/* <form className="px-2"> */}
      <p className="text-primary-red font-Rakkas mt-7 text-center font-semibold tracking-wide underline md:!text-3xl">
        Annual Returns Form
      </p>
      <div className="flex justify-between">
        {/* <div className=" flex space-x-6 text-primary-red text-base font-bold sm:text-lg">
          <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
            <label htmlFor="old">पहिले नै हामीसंग आवद्ध भएको कम्पनी</label>
            <input type="radio" name="radio-btn" id="old"
            onChange={()=> setTurnOn(true)}
            
            />
          </td>
          <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
            <label htmlFor="new">नयाँ कम्पनी </label>
            <input type="radio" name="radio-btn" id="new"
              onChange={()=> setTurnOn(false)}
            />
          </td>
        </div> */}
        <Option setTurnOn={setTurnOn}/>
        <p className="text-primary-red flex items-center">
          Firm No.
          <span className=" text-primary-blue"> 1234</span>
        </p>
      </div>

      {turnOn ?<OldAnnualForm />:
      <NewAnnualForm/>
  }

      {/* new company for 3 months */}
     

     
    </div>
  );
};

export default AnualReturns;
